import api from '@/core/api'

import type {
	KickPlayerResponse,
	ReinitPlayerResponse,
	SessionActionResponse,
} from '../../type'
import type { paths } from '@/schema'

type GetPlayersResponse =
	paths['/api/admin/operators/players/get-players']['get']['responses']['200']['content']['application/json']

export const kickAllSessions = async (): Promise<SessionActionResponse> => {
	const response = await api.get<SessionActionResponse>(
		'admin/session/kick-all',
	)
	return response.data
}

export const kickPlayer = async (
	playerId: string,
): Promise<KickPlayerResponse> => {
	const response = await api.post<KickPlayerResponse>(
		`admin/session/kick/${playerId}`,
	)
	return response.data
}

export const reinitAllSessions = async (): Promise<SessionActionResponse> => {
	const response = await api.post<SessionActionResponse>(
		'admin/session/reinit-all',
	)
	return response.data
}

export const reinitPlayer = async (
	playerId: string,
): Promise<ReinitPlayerResponse> => {
	const response = await api.post<ReinitPlayerResponse>(
		`admin/session/reinit/${playerId}`,
	)
	return response.data
}

export const getPlayerByPhone = async (
	phone: string,
): Promise<GetPlayersResponse> => {
	const response = await api.get<GetPlayersResponse>(
		'admin/operators/players/get-players',
		{
			params: {
				skip: 0,
				take: 1,
				search: phone,
			},
		},
	)
	return response.data
}
